import React, { Component } from "react";
import { connect } from "react-redux";
import * as userActions from "../../../../_actions/userActions";
import * as appActions from "../../../../_actions/appActions";
import Wrapper from "../../../../_hoc/Wrapper";
import Basic from "./Basic";
import Physical from "./Physical";
import Education from "./Education";
import Family from "./Family";
import Habit from "./Habit";
import Astrology from "./Astrology";

class ProfileInformation extends Component {
  render() {
    const { showToast, updateProfile } = this.props;
    return (
      <Wrapper>
        <Basic update={updateProfile} showToast={showToast} />
        <Education update={updateProfile} showToast={showToast} />
        <Physical update={updateProfile} showToast={showToast} />
        <Family update={updateProfile} showToast={showToast} />
        <Habit update={updateProfile} showToast={showToast} />
        <Astrology update={updateProfile} showToast={showToast} />
      </Wrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateProfile: payload => dispatch(userActions.updateUserProfile(payload)),
  showToast: payload => dispatch(appActions.showToast(payload))
});

export default connect(
  null,
  mapDispatchToProps
)(ProfileInformation);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/index.js